module.exports = __webpack_public_path__ + "img/avatar.1f6c2c9a.png";